import Vue from "vue";

import axios from 'axios'
import $store from '../store'
import toLoginLesson from '@libs/lessonLogin'
import { VUE_APP_API_URL } from '@utils/index'
// import { qryUserIpAddress } from '@api/outer.api'

const instance = axios.create({
  baseURL: VUE_APP_API_URL,
  // baseURL: "http://azgkbv.natappfree.cc",
  timeout: 120000
});
// 获取URL中的查询字符串
const searchParams = window.location.search;
// 使用URLSearchParams解析查询字符串
const params = new URLSearchParams(searchParams);
const defaultOpt = { login: true };

function baseRequest(options) {
  const token = $store.state.app.token;
  const iosToken = sessionStorage.getItem("iosToken");
  var uid = $store.state.app.uid;
  if (!uid) {
    uid = params.get("ticket");
    $store.commit("SET_UID", uid);
  }
  const headers = options.headers || {};
  headers["Authori-zation"] = token;
  headers["ticket"] = uid;
  headers["ios-token"] = iosToken;
  // try {
  //   // const userAddress = qryUserAddress();
  //   headers["lesson-user-ip"] = qryUserIpAddress();
  //   // headers['lesson-user-address'] = userAddress
  // } catch (e) {
  //   console.debug("无法获取到用户IP");
  // }
  options.headers = headers;
  // if (options.login && !token) {
  //   toLogin();
  //   return Promise.reject({ msg: "未登录", toLogin: true });
  // }
  // console.log(options);
  return instance(options).then(res => {
    const data = res.data || {};
    // console.log(res)
    if (res.status !== 200)
      return Promise.reject({ msg: "请求失败", res, data });

    if ([410000, 410001, 410002].indexOf(data.status) !== -1) {
      toLoginLesson();
      return Promise.reject({ msg: res.data.msg, res, data, toLogin: true });
    } else {
      //if (res.status === 200) {
      return Promise.resolve(data, res);
      // } else {
      //   return Promise.reject({ msg: res.data.msg, res, data });
    }
  });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, data, method }, defaultOpt, options)
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, params, method }, defaultOpt, options)
    );
  };
});

export default request;
